export default {
    send_welcome_email_title: "Envió de credenciales por correo",
    send_welcome_email_success_message: "Las credenciales se han enviado",
    send_welcome_email_error_message: "Las credenciales no se pudieron debido a un error",
    send_welcome_email_message: "La siguiente acción va a generar una nueva contraseña y se envía un correo de bienvenida con las credenciales ¿Desea proceder?",
    send_welcome_email_label: "Enviar Credenciales",
    send_welcome_email_disabled: "Enviar correo de bienvenida necesita estar activo en la configuración de la cuenta"
};